/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Pressreleases'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019.2020  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomePressreleases from '../../../components/pressreleases/Home.vue'; // 'Home-Pressreleases' ..

export const routespressreleases = [
    { path: '', component: HomePressreleases },
];



// WEBPACK FOOTER //
// ./src/routes/modules/pressreleases/routes.js